<template>
  <div>
    <v-container class="fill-height pa-0" fluid>
      <Loader :loading="loading"></Loader>
      <v-row class="fill-height pa-0 mx-0 my-auto">
        <v-col cols="12" class="d-flex pa-0 text-center justify-center">
          <p class="font-weight-bold neutral--text pb-4 pt-6">{{ 'Complete Offer' }}</p>
        </v-col>
        <v-col cols="12" class="py-0">
          <label>Comments</label>
          <v-textarea
            v-model="order.comments"
            :placeholder="'Comments'"
            outlined
            clearable
            :rules="requiredRule()"
            class="required"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="pa-0" v-if="!orderSubmitted">
          <v-row style="width: 100%">
            <v-col cols="12">
              <v-btn
                block
                depressed
                rounded
                large
                class="white--text font-weight-bold"
                color="black"
                @click="submitOrderOffer"
                :disabled="!order.comments"
                >{{ 'Complete' }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else cols="12" class="pa-0">
          <v-alert dense text type="success">
            Offer <strong>successfully</strong> completed
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import EventBus from '@/helpers/event-bus';
import util from '@/mixins/util';
import Loader from '@/components/shared/helpers/Loader.vue';

export default {
  name: 'OrderCompletedByProvider',
  components: { Loader },
  mixins: [util],
  data() {
    return {
      order: {
        uuid: null,
        type: null,
        comments: '',
      },
      orderSubmitted: false,
      loading: false,
    };
  },
  mounted() {
    this.order.uuid = this.$route.query.uuid;
    this.order.type = this.$route.query.type;
  },
  methods: {
    submitOrderOffer() {
      this.loading = true;
      if (this.order.type === 'equipment') {
        const payload = {
          uuid: this.order.uuid,
          commends: this.order.comments,
        };

        this.axios
          .put(`/api/v1/orders-equipment/completed-by-provider`, payload)
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Offer successfully completed',
            });
            this.orderSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally((this.loading = false));
      } else if (this.order.type === 'patent') {
        const payload = {
          uuid: this.order.uuid,
          commends: this.order.comments,
        };

        this.axios
          .put(`/api/v1/orders-patent/completed-by-provider`, payload)
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Offer successfully completed',
            });
            this.orderSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally((this.loading = false));
      } else {
        const payload = {
          uuid: this.order.uuid,
          commends: this.order.comments,
        };

        this.axios
          .post(`/api/v1/orders/completed-by-provider`, payload)
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Offer successfully completed',
            });
            this.orderSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally((this.loading = false));
      }
    },
  },
};
</script>
